import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon_arrow_right",
  "use": "icon-icon_arrow_right-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_arrow_right\"><defs><style></style></defs><path d=\"M317.44 926.72a25.6 25.6 0 0 1-18.022-43.622L670.31 512 299.418 140.902a25.6 25.6 0 1 1 36.25-36.25l389.12 389.12a25.6 25.6 0 0 1 0 36.25l-389.12 389.12a25.6 25.6 0 0 1-18.228 7.578z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol